import BenchlingConfig from 'BenchlingConfig';
import preferences from 'Preferences';
import {StudiesPreferences} from 'studies/StudiesPreferences';

/**
 * Gates the flowchart-based procedure run / run plan design UI.
 *
 * Always use this helper rather than directly accessing BenchlingConfig or preferences.
 */
export function shouldShowFlowchartProcedureRunDesign(): boolean {
  return (
    BenchlingConfig.STUDIES_ENABLE_FLOWCHART_PROCEDURE_RUN_DESIGN &&
    preferences.get(StudiesPreferences.SHOW_FLOWCHART_PROCEDURE_RUN_DESIGN)
  );
}

/**
 * Controls whether the flowchart opt-in banner should be shown in legacy run/run-plan design.
 */
export function shouldShowFlowchartProcedureRunDesignOptInBanner(): boolean {
  return (
    BenchlingConfig.STUDIES_ENABLE_FLOWCHART_PROCEDURE_RUN_DESIGN &&
    !preferences.get(StudiesPreferences.SHOW_FLOWCHART_PROCEDURE_RUN_DESIGN)
  );
}

/**
 * Opts the current user into the flowchart run/run-plan design.
 */
export async function optInToFlowchartProcedureRunDesign(): Promise<void> {
  await preferences.set(StudiesPreferences.SHOW_FLOWCHART_PROCEDURE_RUN_DESIGN, true);
}
